import { FieldEditorSectionWithName } from 'components/FieldEditor/types/FieldEditorSection';
import React from 'react';

import { CheckboxWithLabel } from '../CheckboxWithLabel';
import { InputArea } from '../InputArea';

export function ImageMeta({ field, setField }: FieldEditorSectionWithName) {
  const meta = field.meta || {};

  const updateMeta = (updates: any) => {
    setField({
      ...field,
      meta: {
        ...meta,
        ...updates,
      },
    });
  };

  const booleanMeta: any = meta['bf.datamaid.generate_emoji'] || false;

  return (
    <InputArea name="Meta" description="Meta configuration for sortable fields">
      <CheckboxWithLabel
        label="Automatically generate an emoji with DataMaid"
        description={
          <>
            Anytime an entity of this type is visited, datamaid will attempt to
            generate an emoji if this If the field is already populated with a
            value, datamaid will not attempt to generate an emoji. The only data
            used in generating the emoji is the entity name and parent names.
          </>
        }
        checked={booleanMeta}
        setChecked={(v) =>
          updateMeta({
            'bf.datamaid.generate_emoji': v,
          })
        }
      />
    </InputArea>
  );
}
